import { InjectionToken } from "@angular/core";
import { CompanyDigitalPayslipsPort } from "./company-digital-payslips.port";

export const COMPANY_DIGITAL_PAYSLIPS_PORT =
  new InjectionToken<CompanyDigitalPayslipsPort>(
    "COMPANY_DIGITAL_PAYSLIPS_PORT",
  );
